import React, { useEffect, useState } from 'react';
import { Lock } from 'lucide-react';
import { familyApi, fmtDay } from './familyApi';

const LockedScreen = ({ st, onLogout }) => (
  <div data-testid="family-locked-screen" className="min-h-screen flex items-center justify-center bg-gradient-to-b from-amber-50 to-orange-100 p-6">
    <div className="max-w-md w-full rounded-3xl bg-white border-2 border-amber-300 shadow-xl p-8 text-center space-y-4">
      <div className="mx-auto h-16 w-16 rounded-full bg-amber-100 flex items-center justify-center"><Lock className="text-amber-700" size={30} /></div>
      <h1 className="text-2xl font-bold text-amber-900">Hi {st.name || 'there'} — the protocol is locked today</h1>
      <p data-testid="family-locked-message" className="text-slate-600">
        {st.next_access_date ? <>Your next access day is <b data-testid="family-locked-next-date">{fmtDay(st.next_access_date)}</b> (Adelaide time).</> : st.message}
      </p>
      <p className="text-xs text-slate-400">Phone alerts are also paused until your next access day.</p>
      <button type="button" data-testid="family-locked-logout" onClick={onLogout}
        className="rounded-xl bg-amber-500 hover:bg-amber-600 text-white font-bold px-6 py-2.5 transition-colors">Sign out</button>
    </div>
  </div>
);

export const FamilyAccessGate = ({ enabled, onLogout, children }) => {
  const [st, setSt] = useState(null);
  useEffect(() => {
    if (!enabled) { setSt(null); return undefined; }
    const check = () => familyApi.me().then(setSt).catch(() => {});
    check();
    const t = setInterval(check, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [enabled]);
  if (enabled && st && st.managed && !st.has_access_today) return <LockedScreen st={st} onLogout={onLogout} />;
  return children;
};
